import './craneclub/style';
import FormStructure from './craneclub/form_structure';

export default FormStructure;